import { UntypedFormBuilder, Validators } from '@angular/forms';
import { eGOVPaymentProcessorAccountConfiguration } from './../../../models/payment-providers/egov/egov-payment-processor-account-configuration';
import { PaymentAccountConfigBaseComponent } from './../payment-account-config-base/payment-account-config-base.component';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'wm-payment-account-config-egov',
    templateUrl: './payment-account-config-egov.component.html',
    styleUrls: ['./payment-account-config-egov.component.css'],
    standalone: false
})
export class PaymentAccountConfigeGOVComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {
  @Input() config: eGOVPaymentProcessorAccountConfiguration;

  constructor(fb: UntypedFormBuilder) {
    super(fb);
    this.showPassword = false;
    this.showUsername = false;
  }

  ngOnInit() {
    this.addValidation(
      'serviceCode',
      Validators.required,
      this.config.serviceCode
    );
    this.addValidation(
      'merchantID',
      Validators.required,
      this.config.merchantID
    );
    this.addValidation(
      'merchantKey',
      Validators.required,
      this.config.merchantKey
    );
    this.addValidation('stateCode', Validators.required, this.config.stateCode);
  }
}
